import forIn from 'lodash/forIn';
import {
  ENG_TOGGLE_GRAPHICS,
  ENG_TOGGLE_GRAPHICS_FAILURE,
  ENG_SET_GRAPHICS_STATUS,
  ENG_INIT,
} from '../../constants/engineering';
import { STATUS_ON, STATUS_OFF, STATUS_LOADING } from '../../constants/common';

const validStati = [STATUS_ON, STATUS_OFF, STATUS_LOADING];

export const defaultState = {};

const graphics = (state = defaultState, action) => {
  switch (action.type) {
    case ENG_INIT:
      if (action.data.graphics) {
        let status = {};
        forIn(action.data.graphics, (graphics, node) => {
          if (graphics.status) {
            status[node] = graphics.status === 'on' ? STATUS_ON : STATUS_OFF;
          }
        });
        return { ...state, ...status };
      } else {
        return state;
      }
    case ENG_TOGGLE_GRAPHICS:
      return { ...state, [action.node]: STATUS_LOADING };
    case ENG_TOGGLE_GRAPHICS_FAILURE:
      return { ...state, [action.node]: STATUS_OFF };
    case ENG_SET_GRAPHICS_STATUS:
      if (validStati.indexOf(action.status) < 0) {
        return state;
      }
      return { ...state, [action.node]: action.status };
    default:
      return state;
  }
};

export default graphics;
